import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { loadSides, loadKpiConfig } from './actions/Beacon4BlendedActions';
import Beacon4BlendedFilterBar   from './components/filters/Beacon4BlendedFilterBar';
import Beacon4BlendedLegendPanel from './components/filters/Beacon4BlendedLegendPanel';
import Beacon4BlendedView        from './components/Beacon4BlendedView';

const theme = createTheme({
    palette: {
        primary:    { main: '#1565c0' },
        background: { default: '#f0f2f5', paper: '#fff' },
    },
    typography: { fontFamily: "'IBM Plex Sans', 'Roboto', sans-serif" },
    components: {
        MuiPaper: { styleOverrides: { root: { backgroundImage: 'none' } } },
    },
});

function Dashboard() {
    const dispatch      = useDispatch();
    const containerRef  = useRef(null);
    const { platform, type } = useSelector(s => s.filters);
    const [showLegend, setShowLegend] = useState(true);

    useEffect(() => {
        dispatch(loadSides({ platform, type }));
        dispatch(loadKpiConfig());
    }, [platform, type, dispatch]);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', bgcolor: '#f0f2f5', height: '100%' }}>
            <Beacon4BlendedFilterBar
                showLegend={showLegend}
                onToggleLegend={() => setShowLegend(v => !v)}
                containerRef={containerRef}
            />
            <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
                <Box sx={{ flex: 1, minWidth: 0, overflowY: 'auto', p: '12px 16px' }}>
                    <Beacon4BlendedView ref={containerRef} />
                </Box>
                <Beacon4BlendedLegendPanel
                    open={showLegend}
                    onToggle={() => setShowLegend(v => !v)}
                />
            </Box>
        </Box>
    );
}

export default function App() {
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Dashboard />
        </ThemeProvider>
    );
}